module.exports = __webpack_public_path__ + "img/baccaratcardsarea.1d83ff75.png";